module.exports = __webpack_public_path__ + "img/ic_price_black.cd1e9dc3.svg";